module.exports = __webpack_public_path__ + "static/img/img_over2.c93a0df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_over2.png
// module id = 5wqa
// module chunks = 1